import { render, staticRenderFns } from "./ListSetting.vue?vue&type=template&id=93972b14&scoped=true"
import script from "./ListSetting.vue?vue&type=script&lang=js"
export * from "./ListSetting.vue?vue&type=script&lang=js"
import style0 from "./ListSetting.vue?vue&type=style&index=0&id=93972b14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93972b14",
  null
  
)

export default component.exports